"use client";


import SectionPage from "@/components/common/section-page";
import InformationsEssentiellesCard from "@/components/site-officiel/accueil/informations-essentielles-card";
import EvenementCard from "@/components/site-officiel/accueil/evenement-card";
import DecouvrirCiCard from "@/components/site-officiel/accueil/decouvrir-ci-card";
import VivezVotreExperienceSection from "@/components/site-officiel/accueil/vivez-votre-experience-section";
import HomeBannerVideo from "@/components/site-officiel/accueil/home-banner-video";

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import RemplissezVosJoursDeVie from "@/components/site-officiel/accueil/remplissez-vos-jours-de-vie";
import NosLocaux from "@/components/site-officiel/accueil/nos-locaux";
// TODO: Replace with React.lazy - next/dynamic removed during Vite migration
// const WelcomeVideo = React.lazy(() => import("@/components/site-officiel/accueil/welcome-video"));

export default function Home() {

    return (
        <>
            <HomeBannerVideo />

            <div className={"flex flex-col gap-6 my-6"}>
                <SectionPage sectionType="2xl">
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Accueil</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator/>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Site Officiel</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </SectionPage>

                <VivezVotreExperienceSection/>

                <SectionPage sectionType="2xl">
                    <RemplissezVosJoursDeVie />
                </SectionPage>

                <SectionPage sectionType="2xl">
                    <DecouvrirCiCard/>
                </SectionPage>

                <SectionPage sectionType="2xl">
                    <NosLocaux/>
                </SectionPage>

                <SectionPage sectionType="2xl">
                    <EvenementCard/>
                </SectionPage>

                <SectionPage sectionType="2xl">
                    <InformationsEssentiellesCard/>
                </SectionPage>
            </div>
        </>
    );
}
